module.exports = __webpack_public_path__ + "img/901691059.c146ad06.png";